import styled from "styled-components";
import { Icon, Anchor } from "@ebscois/react-component-library";

export const StyledTableWrapper = styled.div`
  width: fit-content;
  margin-bottom: ${({ theme }) => theme.space.xs};

  @media print {
    display: none;
  }
`;

const getColor = ({ theme, withBackground, isStandAlone }) => {
  if (withBackground) {
    return isStandAlone ? theme.colors.gray100 : theme.colors.quinary.base;
  }
  return "transparent";
};

export const StyledTableAnchor = styled(Anchor)`
  display: inline-flex;
  align-items: ${({ isStandAlone, isRightRails }) =>
    !isStandAlone || isRightRails ? "flex-start" : "center"};
  padding: ${({ withBackground, isStandAlone }) =>
    withBackground && isStandAlone ? "0.6rem 0.75rem" : 0};
  border: ${({ theme, withBackground, isStandAlone }) =>
    withBackground && isStandAlone ? `1px solid ${theme.colors.gray400}` : 0};
  background-color: ${({ theme, withBackground, isStandAlone }) =>
    getColor({ theme, withBackground, isStandAlone })};
  text-decoration: none;

  :hover {
    text-decoration: underline;
  }
`;

export const StyledTableIconStudySummary = styled(Icon)`
  fill: ${({ theme }) => theme.colors.anchor};
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.15rem;
  margin-top: 0.15rem;
`;

export const StyledTableIconStandAlone = styled.img`
  margin-right: ${({ theme }) => theme.space.sm};
`;

export const StyledTableTitle = styled.span`
  color: ${({ theme }) => theme.colors.gray800};
`;

export const StyledCaption = styled.span`
  font-size: ${({ theme, isRightRails }) =>
    isRightRails ? theme.font.size.sm : theme.font.size.md};
  line-height: ${({ theme, isRightRails }) =>
    isRightRails ? "19px" : theme.line.height.h2};
`;

export const StyledTableForPrint = styled.div`
  display: none;

  @media print {
    display: block;
  }
`;
